import {isMobile} from "react-device-detect";
import {isUndefined} from 'lodash';

import {useEffect, useState} from 'react';

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import {CKEditor} from '@ckeditor/ckeditor5-react'

import {DEFAULT_CITY} from 'ultra/const/general';
import {getClientCity, getClientEnv} from 'ultra/configs/general';
import {getClientImageUrl} from 'ultra/configs/general';

import {useToasterStore} from '../../../Stores/toster';
import {useFormStore} from '../../../Stores/form';

import {useGlobalCustomContext} from '../../../Helpers/context';

import ContentUploadPlugin from './ContentUploadPlugin';

import './index.scss'

export default function CKEditorControl(props) {
    const {content, disabled, field, isEditMode, onChange, onBlur, className, formActions} = props;

    const {setVisibleError, clearVisibleError, formVisibleErrors} = useFormStore();
    const showErrorText = formVisibleErrors[field.id];

    const {showSuccess, showError} = useToasterStore();

    const {userState} = useGlobalCustomContext();

    const [isDisabled, setIsDisabled] = useState(disabled || field?.options?.disabled || (isEditMode && field.notEditable))
    useEffect(() => {setIsDisabled(disabled || field?.options?.disabled || (isEditMode && field.notEditable)) }, [disabled])

    const [placeholder, setPlaceholder] = useState("")

    // const [preloading, setPreloading] = useState();
    const [characters, setCharacters] = useState(0);

    const [value, setValue] = useState();
    const [editorConfiguration, setEditorConfiguration] = useState(null);

    useEffect(() => {
        const extraPlugins = []

        extraPlugins.push(function FileUpload(editor) {
            if (userState?.user) {
                ContentUploadPlugin(editor, field.id, content._did, content.title, content._type, content._created_by, formActions);    // !!!! , user?.accessToken
            }
        })

        extraPlugins.push(function Notifications(editor) {
            const notifications = editor.plugins.get('Notification');
            notifications.on('show:warning', (evt, _data) => {
                const message = {
                    snackbarMessage: _data.title + ': ' + _data.message,
                    snackbarDuration: 10000
                };
    
                if (_data.type === 'warning') {
                    showError(message);
                } else {
                    showSuccess(message);
                };
    
                evt.stop();
            });
        });
    
        let items = [
            'undo', 'redo', 'heading',
            '|', 'bold', 'italic',
            '|', 'bulletedList', 'numberedList',
            '|', 'link',
            '|'
        ]

        if (userState?.user) items.push('imageUpload')
    
        if (field?.options?.extended) {
            items = [
                'undo', 'redo', 'heading',
                '|', 'alignment', 'bold', 'italic',
                'bulletedList', 'numberedList',
                '|', 'link'
            ]
        
            if (userState?.user) items.push('imageUpload')
        
            items.push('insertTable')
            items.push('|')
            items.push('blockQuote')            
        }

        if (field?.options?.noToolbar) {
            items = []
        }

        if (isMobile) {
            items = []
        }

        const editorConfig = {
            toolbar: {
                items,
                // shouldNotGroupWhenFull: true
            },
            mediaEmbed: {
                removeProviders: [ 'instagram', 'twitter', 'googleMaps', 'flickr', 'facebook' ]
            },
            image: {
                resizeUnit: 'px'
            },
            // placeholder: placeholder,
            extraPlugins,
        }

        if (field?.options?.maxLength) {
            editorConfig.wordCount = {
                // showCharCount: true, // Show character count
                countHTML: false,
                countSpacesAsChars: true, // Count spaces
                maxCharCount: field?.options?.maxLength, // Set max characters
                displayWords: false,
                displayCharacters: true
            }
        }

        setEditorConfiguration(editorConfig);
    }, [])

    useEffect(() => {
        const env = getClientEnv(window);
        const city = content._city || getClientCity(window) || DEFAULT_CITY;
        const path = getClientImageUrl(env, city, '');
        if (content[field.id]) {
            setValue(content[field.id]?.replaceAll('src="', `src="${path}`));
        }
        else {
            setValue("");
        }

        setPlaceholder(field.placeholder ? field.placeholder + (field.required ? ' *' : '') : undefined)
    }, [content[field.id]])

    if (!editorConfiguration) {
        return <></>
    }

    return <>
        <div className={'CKEditor' + (className ? ' ' + className : '') + (showErrorText ? ' error' : '') + (isDisabled ? ' disabled' : '') + (editorConfiguration?.toolbar?.items.length === 0 ? ' noPanel' : '')}>
            <div className="placeholder">{placeholder}:</div>
            {/* {preloading && <div className="PreloaderWrap"><Preloader /></div>} */}
            <CKEditor
                editor={Editor}
                disabled={isDisabled}
                config={editorConfiguration}
                data={value}
                onChange={(e, editor) => {
                    const value = editor.getData();

                    // it was reset:
                    if (isUndefined(content[field.id]) && value === '') return;

                    const stats = editor.plugins.get('WordCount');
                    const currentChars = stats.characters;
                    setCharacters(currentChars)
                    // const currentWords = stats.words;
                    // setWords(currentWords)

                    if (currentChars > field?.options?.maxLength) {
                        // setIsLimitExceeded(true);
                        // // Optional: Truncate the content immediately to prevent exceeding the limit visually
                        // // This is a common workaround as stopping input is complex in CKEditor 5
                        // // The snippet below sets the data back to the allowed length
                        // const truncatedData = data.substring(0, limit); 
                        // setEditorData(truncatedData);
                        // editor.setData(truncatedData);

                        setVisibleError(field.id, "Перевищено максимальну кількість: " + currentChars + "/" +  + field.options.maxLength + " символів");

                        // ?? onChange({target: {value}});
                    } else {
                        clearVisibleError(field.id)
                    }
                    onChange({target: {value}});
                }}
                onBlur={(e, editor) => {
                    const value = editor.getData();
                    if (onBlur) onBlur({target: {value}});
                }}
            />

            {isDisabled && !value && <div className='disabledLabel'>{editorConfiguration.placeholder}</div>}

            {field?.options?.maxLength && field?.options?.maxLength && <div className="fieldNotes">
                <div className="maxLength">
                    <p>* максимальна кількість символів - {field.options.maxLength}</p>
                    {characters > 0 && <span className={"characters " + (characters > field.options.maxLength ? "error" : "")}>{characters}</span>}
                    {/* Використано: {characters} / {words} */}
                </div>
            </div>}
            {showErrorText && <div className='fieldError'>{showErrorText}</div>}
            {/* {isEmptyObj(user) && <p className='fieldNotes'>* Завантажити картинку може лише <RouterLink to="/profile/login">авторизований користувач</RouterLink></p>} */}
        </div>
    </>
}
